import {
  mediaFragment,
} from '~/gql/mediaFragments.gql'

export const heroCarouselBlock = `
  overlayOpacity
  slideDuration
  slideTransitionDuration
  slides {
    showCategory
    article {
      slug
      date
      _firstPublishedAt
      createdAt
      title
      subtitle
      category {
        slug
      }
    }
    ${mediaFragment('image', '{ q: 40 }')}
    ${mediaFragment('mobileImage', '{ q: 40 }')}
    ${mediaFragment('video', null, false)}
    ${mediaFragment('mobileVideo', null, false)}
  }
`